/**
 * Data Provider Factory
 *
 * All data operations go through the BFF API.
 * localStorage mode has been removed.
 */

import { env } from "../../config/env";
import {
	apiDocumentTemplateProvider,
	apiKycProvider,
	apiWalletProvider,
} from "./api";
import type { DataProviders } from "./types";

/**
 * Data providers — always uses API
 */
export const dataProviders: DataProviders = {
	wallet: apiWalletProvider,
	kyc: apiKycProvider,
	documentTemplate: apiDocumentTemplateProvider,
};

// Log data layer config
if (env.isDevelopment) {
	console.log("[Data Layer] Using API provider");
	console.log(`[Data Layer] API URL: ${env.API_URL}`);
}

// Re-export individual providers for direct access if needed
export {
	apiDocumentTemplateProvider,
	apiKycProvider,
	apiWalletProvider,
} from "./api";
// Re-export types
export type {
	DataProviders,
	DocumentTemplateDataProvider,
	KYCDataProvider,
	WalletDataProvider,
} from "./types";
